import React from 'react';

export default function GeneralInfo({
  orderId = 'N/A',
  bundleId = 'N/A',
  courier = 'N/A',
}: {
  orderId: string | number;
  bundleId: string | number;
  courier: string;
}) {
  return (
    <div>
      <span className="box__field">
        <h5>Order ID:</h5>
        <h5>{orderId}</h5>
      </span>
      <span className="box__field">
        <h5>Bundle ID:</h5>
        {bundleId ? <h5>{bundleId}</h5> : <h5>N/A</h5>}
      </span>
      <span className="box__field">
        <h5>Courier:</h5>
        <h5>{courier || 'N/A'}</h5>
      </span>
    </div>
  );
}
